import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Button, Comment, Modal } from 'antd';
import formatDate from 'vl-common/src/lib/formatDate';
import { TimelineNote } from '@components/Clinicians/PatientInformation';

const StyledClinicianNotesHistory = styled.div`
  overflow-y: auto;
  height: 300px;
  justify-content: space-between;
`;

const NonClinicalNote = ({ note }: { note: TimelineNote }) => {
  const { t } = useTranslation('common');
  const { created_by, note_text } = note;
  return (
    <Comment
      author={
        <span>
          {created_by}
          {t(' at ')}
          {formatDate(note.date_added, 'Date @ Time (long, 24h) - Friday, March 3rd, 2022 @ 08:57')}
        </span>
      }
      content={<p>{note_text}</p>}
    />
  );
};
const InternalNotesModal = ({
  previousNotes,
  showInternalNotes,
  setShowInternalNotes
}: {
  previousNotes: TimelineNote[];
  showInternalNotes: boolean;
  setShowInternalNotes: (value: boolean) => void;
}) => {
  const { t } = useTranslation('common');
  return (
    <Modal
      title={t('Internal notes')}
      centered
      open={showInternalNotes}
      styles={{
        body: {
          maxHeight: '600px',
          overflowY: 'auto'
        }
      }}
      onCancel={() => setShowInternalNotes(false)}
      footer={[
        <Button data-testid="close-notes-modal" key="cancel" onClick={() => setShowInternalNotes(false)}>
          {t('Close')}
        </Button>
      ]}
    >
      {previousNotes?.length > 0 ? (
        <StyledClinicianNotesHistory className="clinician-notes-history">
          {previousNotes.map((note, index) => (
            <div style={{ paddingLeft: 10 }} key={index + 1 /* keeps SonarQube happy */}>
              <NonClinicalNote note={note} />
            </div>
          ))}
        </StyledClinicianNotesHistory>
      ) : (
        'No internal notes'
      )}
    </Modal>
  );
};

export default InternalNotesModal;
